"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _preactCompat = require("preact-compat");

var _index = _interopRequireWildcard(require("../../design-system-components/modal/index"));

var _Button = _interopRequireDefault(require("../../../control-components/ui-components/Button"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var _translations = require("../../../libs/translationsUtils/translations");

var _button = require("../../design-system-components/button");

var _form = _interopRequireDefault(require("../../design-system-components/form"));

var _inputUnit = _interopRequireDefault(require("../../design-system-components/input-unit"));

var _textArea = _interopRequireDefault(require("../../design-system-components/text-area"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ReportPrivateMessageModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ReportPrivateMessageModal, _PureComponent);

  var _super = _createSuper(ReportPrivateMessageModal);

  function ReportPrivateMessageModal() {
    (0, _classCallCheck2.default)(this, ReportPrivateMessageModal);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ReportPrivateMessageModal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          senderUsername = _this$props.senderUsername,
          reportedMessage = _this$props.reportedMessage,
          reason = _this$props.reason,
          onReasonChanged = _this$props.onReasonChanged,
          onReport = _this$props.onReport,
          onCancel = _this$props.onCancel,
          errorMessage = _this$props.errorMessage;
      return (0, _preact.h)(_index.default, {
        onClose: onCancel
      }, (0, _preact.h)(_index.ModalHeader, {
        title: (0, _preact.h)(_phrase.default, {
          p: "privateMessages.reportModal.title"
        })
      }), (0, _preact.h)(_index.ModalBody, null, (0, _preact.h)(_form.default, null, (0, _preact.h)("p", null, (0, _preact.h)(_phrase.default, {
        p: "privateMessages.reportModal.text"
      })), (0, _preact.h)(_inputUnit.default, {
        label: (0, _translations.t)('Forum', 'privateMessages.reportModal.sender')
      }, (0, _preact.h)("span", null, senderUsername)), (0, _preact.h)(_inputUnit.default, {
        label: (0, _translations.t)('Forum', 'privateMessages.reportModal.message')
      }, (0, _preact.h)("div", {
        dangerouslySetInnerHTML: {
          __html: reportedMessage
        }
      })), (0, _preact.h)(_inputUnit.default, {
        label: (0, _translations.t)('Forum', 'privateMessages.reportModal.reasons'),
        error: errorMessage
      }, (0, _preact.h)(_textArea.default, {
        adjustHeight: true,
        maxLength: 1500,
        onContentChange: onReasonChanged,
        placeholder: (0, _translations.t)('Forum', 'privateMessages.reportModal.reasons.placeholder'),
        value: reason,
        verticalResize: true
      })))), (0, _preact.h)(_index.ModalFooter, null, (0, _preact.h)(_button.ButtonGroup, null, (0, _preact.h)(_Button.default, {
        className: "btn--cancel",
        onClick: onReport
      }, (0, _preact.h)(_phrase.default, {
        p: "privateMessages.reportModal.reportButton"
      })), (0, _preact.h)(_Button.default, {
        className: "btn--secondary",
        onClick: onCancel
      }, (0, _preact.h)(_phrase.default, {
        p: "privateMessages.reportModal.cancelButton"
      })))));
    }
  }]);
  return ReportPrivateMessageModal;
}(_preactCompat.PureComponent);

var _default = ReportPrivateMessageModal;
exports.default = _default;